import {
    Box,
    Checkbox,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer, TableHead, TablePagination,
    TableRow,
    Button, Dialog, DialogTitle, DialogContent, DialogActions, useMediaQuery
} from "@mui/material";
import {useMemo, useState} from "react";
import {useTheme} from "@mui/material/styles";

function WordSelectionDialogView({words, initiallySelected, confirmationCallback, cancelCallback}) {

    const theme = useTheme();

    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const [selectedWords, setSelectedWords] = useState(initiallySelected ? initiallySelected : words);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(isMobile ? 10 : 20);

    const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - words.length) : 0;

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const visibleRows = useMemo(() =>
            words.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage),
        [page, rowsPerPage],
    );

    const handleRowChecked = (event, word) => {
        if (event.target.checked) {
            setSelectedWords([...selectedWords, word]);
        }
        else {
            setSelectedWords(selectedWords.filter((w) => w !== word));
        }
    };

    function SelectionTable() {
        return (
            <Box sx={{ width: '100%' }}>
                <Paper sx={{ width: '100%', mb: 2 }}>
                    {/*<EnhancedTableToolbar numSelected={selected.length} />*/}
                    <TableContainer>
                        <Table
                            sx={{ minWidth: 750 }}
                            aria-labelledby="tableTitle"
                            size="small"
                        >
                            <TableHead>
                                <TableRow>
                                    <TableCell padding="checkbox">
                                        <Checkbox
                                            color="purple"
                                            indeterminate={selectedWords.length > 0 && selectedWords.length < words.length}
                                            checked={words.length > 0 && selectedWords.length === words.length}
                                            onChange={e => setSelectedWords(e.target.checked ? words : [])}
                                            inputProps={{'aria-label': 'select words'}}
                                        />
                                    </TableCell>
                                    <TableCell>Word</TableCell>
                                    <TableCell>Translation</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {visibleRows.map((word, index) => {
                                    const isItemSelected = selectedWords.includes(word);
                                    const labelId = `enhanced-table-checkbox-${index}`;

                                    return (
                                        <TableRow
                                            hover
                                            onClick={(event) => handleRowChecked(event, word)}
                                            role="checkbox"
                                            aria-checked={isItemSelected}
                                            tabIndex={-1}
                                            key={index}
                                            selected={isItemSelected}
                                            sx={{ cursor: 'pointer' }}
                                        >
                                            <TableCell padding="checkbox">
                                                <Checkbox
                                                    color="purple"
                                                    checked={isItemSelected}
                                                    inputProps={{'aria-labelledby': labelId}}
                                                />
                                            </TableCell>
                                            <TableCell>{word.word}</TableCell>
                                            <TableCell>{word.translation}</TableCell>
                                        </TableRow>
                                    );
                                })}
                                {emptyRows > 0 && (
                                    <TableRow
                                        style={{
                                            height: (33) * emptyRows,
                                        }}
                                    >
                                        <TableCell colSpan={6} />
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <TablePagination
                        rowsPerPageOptions={isMobile ? [10] : [10, 20, 50]}
                        component="div"
                        count={words.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={(event, newPage) => setPage(newPage)}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'end',
                            '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
                                margin: 0,
                                lineHeight: '32px',
                            },
                            '& .MuiTablePagination-actions': {
                                display: 'flex',
                                alignItems: 'center',
                            },
                            '& .Mui-selected': {
                                width: '10',
                                height:'100',
                            },
                        }}
                    />
                </Paper>
            </Box>
        )
    }

    return (
        <Dialog open={true} maxWidth="md">
            <DialogTitle>Select words to add</DialogTitle>
            <DialogContent>
                <SelectionTable/>
            </DialogContent>
            <DialogActions>
                <Button color="inherit" onClick={cancelCallback}>
                    Cancel
                </Button>
                <div style={{flex: '1 0 0'}}/>
                <Button color="purple"
                        onClick={() => confirmationCallback(selectedWords)}
                        disabled={selectedWords.length === 0}>
                    {`Select ${selectedWords.length} words`}
                </Button>
            </DialogActions>
        </Dialog>
    )

}

export default WordSelectionDialogView;